import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to hire someone to build a mobile app?",
    answer: ` <p>It can cost from $10,000 to $40,000 and more to develop a simple app with basic functionality such as a calculator or flashlight app. For complex apps such as a social media or e-commerce app, it can cost between $30,000 to $500,000 and more.</p>`,
  },
  {
    question: " How much does it cost to build a mobile app in the UK?",
    answer: `<p>The cost to build a simple app in UK is around £10,000, while a more complex one may cost up to £1 million. Other than that, if you’re trying to build an average app then it can range from £30,000 to £140,000.</p>`,
  },
  {
    question: " What are custom application development services?",
    answer: ` <p>Custom application development is the process of designing, developing, and deploying software applications designed for particular users or use cases.</p>`,
  },
  {
    question: " How long does it take to develop a mobile app in UK?",
    answer: ` <p>Here are the estimated time frames to develop mobile applications of different complexities:</p> 
        <ul>
        <li><strong>Simple App Development :</strong> 2 - 4 months</li>
        <li><strong>Average App Development :</strong> 4 - 6 months</li>
        <li><strong>Complex App Development :</strong> 9+ months</li>
    </ul>`,
  },
  {
    question: "Do you provide app design services in UK as well?",
    answer: ` <p>Yes, TekRevol offers custom website design services in UK delivering the best UI/UX and a handful of other practices.</p>
        <p>TekRevol’s common metrics for top-notch app designs include:</p>  
        <ul>
        <li>Improved User Experience</li>
        <li>Improved SEO ratings</li>
        <li>Conversion Rate Optimization</li>
        <li>Successful Digital Rebranding & Design</li>
        <li>Intuitive User Interface</li>
        </ul>`,
  },
  {
    question:
      "Why should I hire a mobile application development company in UK?",
    answer: `  <p>Yes, TekRevol offers custom website design services in UK delivering the best UI/UX and a handful of other practices. TekRevol’s common metrics for top-notch app designs include:</p>
        <p>You should hire a mobile app development company in UK to be time-effective and cost-efficient in various development phases.</p>
        <p>App developers in London can effectively construct a mobile app that aligns with your business needs. </p>
        <p>Furthermore, TekRevol’s app developers in UK offer post-delivery app maintenance & support services, alleviating the need for entrepreneurs to spend money repeatedly.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
